import { render, staticRenderFns } from "./FeedEditorProjectSelect.vue?vue&type=template&id=60aa531e&scoped=true&"
import script from "./FeedEditorProjectSelect.vue?vue&type=script&lang=js&"
export * from "./FeedEditorProjectSelect.vue?vue&type=script&lang=js&"
import style0 from "./FeedEditorProjectSelect.vue?vue&type=style&index=0&id=60aa531e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa531e",
  null
  
)

export default component.exports